export const OPEN_COPY_FILTER_MODAL = 'state.actions.copy-filter-modal.OPEN_COPY_FILTER_MODAL';

export type OpenCopyFilterModalAction = {
	type: typeof OPEN_COPY_FILTER_MODAL;
};

export const openCopyFilterModal = (): OpenCopyFilterModalAction => ({
	type: OPEN_COPY_FILTER_MODAL,
});

export const CLOSE_COPY_FILTER_MODAL = 'state.actions.copy-filter-modal.CLOSE_COPY_FILTER_MODAL';

export type CloseCopyFilterModalAction = {
	type: typeof CLOSE_COPY_FILTER_MODAL;
};

export const closeCopyFilterModal = (): CloseCopyFilterModalAction => ({
	type: CLOSE_COPY_FILTER_MODAL,
});

export type Action = OpenCopyFilterModalAction | CloseCopyFilterModalAction;
